<mat-expansion-panel
        class="dynamic-form-set"
        *ngIf="sublist"
        [hideToggle]="!collapsible"
        [expanded]="!collapsed">
    <mat-expansion-panel-header>
        <mat-panel-title>
            {{getLabel() | translate}}
        </mat-panel-title>
    </mat-expansion-panel-header>
    <mx-dynamic-fields
            [form]="form"
            [fields]="sublist"
            [errorMessage]="errorMessage"
            [readonlyMode]="formReadonlyMode"
            [fieldConfigs]="fieldConfigs">
    </mx-dynamic-fields>
</mat-expansion-panel>
